import { text } from "../text";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faCalendarCheck,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faSquareEnvelope } from "@fortawesome/free-solid-svg-icons";
import { PropertyType, RoomType } from "../../src/types/types";
import { leadIdFromStorage } from "../environment";
import { callService } from "../customHook/callService";
import { useState } from "react";

type Props = {
  review: PropertyType;
  isLast: boolean;
  onCalendarClick?: () => void;
};

export const PropertiyOwner: React.FC<Props> = ({
  review,
  isLast,
  onCalendarClick,
}) => {

    const [isModalOpen2, setisModalOpen2] = useState(false)

    const handleReuestOwnerCall = () => {

      // console.log(leadIdFromStorage, "handleReuestOwnerCall", review?.property_id)
      
      const propertyId = review?.property_id;
  
          if (leadIdFromStorage && propertyId) {
            callService("CONTACT_OWNER", [
              {
                param: "PROPERTY_ID",
                value: propertyId,
              },
            ])
              .then((res) => {
                // console.log("✅ CONTACT_OWNER response:", res);    
                      setisModalOpen2(true)    
              })
              .catch((err) => {
                console.error("❌ CONTACT_OWNER API failed:", err);
              });
          }
    }
  
  return (
  <>

       <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginBottom: isLast ? 0 : 20,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F9FAFC",
        borderRadius: 6,
        padding: 15,
        border: "1px solid ##EFEEFB",
      }}
    >
      <div style={{ width: "100%" }}>
        <p >
          {review.property_name}
        </p>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <text.T14 style={{ color: "var(--secondary-color)" }}>
            Owner
          </text.T14>

          <div
            style={{
              display: "flex",
              gap: 20,
              marginRight: 6,
            }}
          >
          </div>
        </div>
      </div>      
    </div>

    {/* <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginBottom: isLast ? 0 : 20,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F9FAFC",
        borderRadius: 6,
        padding: 15,
        border: "1px solid ##EFEEFB",
      }}
    >
      <img
        src="https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
        alt="review"
        style={{ width: 50, height: 50, borderRadius: 35, marginRight: 10 }}
      />
      <div style={{ width: "100%" }}>
        <text.H5 style={{ marginBottom: 0 }} numberOfLines={1}>
          {review.property_name}
        </text.H5>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <text.T14 style={{ color: "var(--secondary-color)" }}>
            Owner
          </text.T14>

          <div
            style={{
              display: "flex",
              gap: 20,
              marginRight: 6,
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                backgroundColor: "var(--secondary-color)", 
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={()=>handleReuestOwnerCall()}

            >
              <FontAwesomeIcon
                icon={faPhone}
                style={{ color: "white", width: 22, height: 22 }}
              />
            </div>
            <div
              style={{
                width: 44,
                height: 44,
                backgroundColor: "#ffc107",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={onCalendarClick}
            >
              <FontAwesomeIcon
                icon={faCalendarCheck}
                style={{ color: "black", width: 22, height: 22 }}
              />
            </div>
          </div>
        </div>
      </div>      
    </div> */}

          {isModalOpen2 && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2></h2>
            <p></p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                alt="Success"
                src={require("../assets/nestfin/Nestfin_logo.png")}
                style={{ width: "50%", height: "auto", marginBottom: 10 }}
              />
            <img
                alt="Success"
                // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                src={require("../assets/other/checked.png")}
                style={{ width: "30%", height: "auto", margin: "30px 0" }}
              />
              <h2 style={{ textAlign: "center", marginBottom: 10 }}>
                Request Sent Successfully
              </h2>
              <text.T16
                style={{
                  whiteSpace: "pre-line",
                  textAlign: "center",
                  marginBottom: 24,
                }}
              >
                Thank you! Our team will get in touch with you shortly.
              </text.T16>
             <div
                onClick={() => {
                  setisModalOpen2(false);
                }}
                style={{
                  width: "100%",
                  // color: theme.colors.white,
                  color:"#fff",
                  height: 40,
                  textAlign: "center",
                  fontSize: 14,
                  borderRadius: 10,
                  userSelect: "none",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  background: "#000000d1",
                  fontFamily: "Lato-Bold",
                  marginTop: 12, // optional spacing
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </div>
      )}
  
  </>
  );
};
